// @ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import CompSearchField from "components/CompSearchField";
import CompDropdown from "components/CompDropdown";
import Typography from "@mui/material/Typography";
import TableConsultation from "components/TableAgent";
import Title from "components/Title";
import * as S from "./styles";
import { useApi } from "hooks/useApis";
import { z } from "zod";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  a_type_options,
  a_status_options,
  sort_options,
  distributionPoints,
} from "utils/constants";
import { CircularProgress } from "@mui/material";
import * as palette from "styles/variables";
import CompAutocomplete from "components/CompAutocomplete";
import { Grid } from "@mui/material";

const AgentManagement = () => {
  const api = useApi();
  const [agentList, setAgentList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [changePage, setChangePage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalAgents, setTotalAgents] = useState(0);

  const abortControllerRef = useRef(null);

  const createAgentSearchSchema = z.object({
    a_status: z.string().optional(),
    agent_type: z.string().optional(),
    search: z.string().optional(),
    sort: z.string(),
    city: z.string().optional(),
  });

  const methods = useForm({
    resolver: zodResolver(createAgentSearchSchema),
    mode: "all",
    criteriaMode: "all",
    defaultValues: getDefaultFilters(),
  });

  const a_status_value = methods.watch("a_status");
  const agent_type_value = methods.watch("agent_type");
  // const search_value = methods.watch("search");
  const sort_value = methods.watch("sort");
  const city_value = methods.watch("city");

  useEffect(() => {
    setChangePage(currentPage);
    methods.handleSubmit((data) => onSubmit(data, currentPage), onError)();
  }, [currentPage]);

  useEffect(() => {
    methods.handleSubmit((data) => onSubmit(data, 1), onError)();
  }, [a_status_value, agent_type_value, sort_value, city_value]);

  async function onSubmit(data, pageNumber) {
    try {
      setLoading(true);
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      const controller = new AbortController();
      abortControllerRef.current = controller;

      const filteredList = await api.listAgent(
        data.a_status,
        data.agent_type,
        data.search,
        data.sort,
        data.city,
        pageNumber,
        { signal: controller.signal }
      );
      if (filteredList.code === "ERR_CANCELED") {
        return;
      }

      setChangePage(pageNumber);
      setAgentList(filteredList.results);
      setTotalPages(filteredList.total_pages);
      setTotalAgents(filteredList?.count);
      sessionStorage.setItem("cria-web@agentFilters", JSON.stringify(data));
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }

  function onError(errors) {
    console.log("Failed to submit:", errors);
  }

  // @ts-ignore
  const [searchTerm, setSearchTerm] = useState("");

  // @ts-ignore
  const handleSearch = () => {
    //onSearch(searchTerm);
  };

  // @ts-ignore
  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // @ts-ignore
  const handleKeyPress = (e) => {
    // if (e.key === 'Enter') {
    //   handleSearch();
    // }
  };

  return (
    <S.PageContainer>
      <Title
        titleText="Gerência de agentes"
        subtitleTexts={["Início", "Gerência de agentes"]}
      />
      <S.PageContent>
        <S.MainContainer>
        <FormProvider {...methods}>
  <S.Form onSubmit={methods.handleSubmit((data) => onSubmit(data, 1))}>
    <Grid container spacing={2}>
      {/* Linha 1 - Busca do agente + Tipo de agente */}
      <Grid item xs={12} sm={6}>
        {/* <S.DateFieldsContainer> */}
          <S.DateFieldsTitle>BUSCA DO AGENTE</S.DateFieldsTitle>
          <CompSearchField
            placeholder="Digite o nome ou CPF para buscar"
            name="search"
            register={methods.register}
            unregister={methods.unregister}
            fullWidth
          />
        {/* </S.DateFieldsContainer> */}
      </Grid>

      <Grid item xs={12} sm={6}>
        <CompDropdown
          textLabel="TIPO DE AGENTE"
          options={a_type_options}
          name="agent_type"
          register={methods.register}
          unregister={methods.unregister}
          fullWidth
        />
      </Grid>

      {/* Linha 2 - Município e Status do Agente */}
      <Grid item xs={12} sm={6}>
        <CompAutocomplete
          textLabel="MUNICÍPIO:"
          options={distributionPoints}
          name="city"
          placeholder="Selecione um município"
          register={methods.register}
          unregister={methods.unregister}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <CompDropdown
          textLabel="STATUS DO AGENTE"
          options={a_status_options}
          name="a_status"
          register={methods.register}
          unregister={methods.unregister}
          fullWidth
        />
      </Grid>
    </Grid>
    <S.CabecalhoTabela>
        <div>
          <Typography variant="h6">Lista de Agentes</Typography>
          <p style={{ fontWeight: "normal" }}>
            {totalAgents?.toLocaleString("pt-BR")} agentes
          </p>
        </div>
        <CompDropdown
          style={{ flexGrow: "0" }}
          defaultValue="0"
          options={sort_options}
          name={"sort"}
          register={methods.register}
          unregister={methods.unregister}
        />
      </S.CabecalhoTabela>
  </S.Form>
</FormProvider>


          {loading ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress style={{ color: `${palette.lightAmarelo}` }} />
            </div>
          ) : (
            <TableConsultation
              agentList={agentList}
              page={changePage}
              totalPages={totalPages}
              setPage={setCurrentPage}
              loading={loading}
            />
          )}
        </S.MainContainer>
      </S.PageContent>
    </S.PageContainer>
  );
};

function getDefaultFilters() {
  return (
    JSON.parse(sessionStorage.getItem("cria-web@agentFilters")) || undefined
  );
}

export default AgentManagement;
